import { BaSePopupButton, BaSeSmall1 } from '@base/react';
import React from 'react';
import { ContainerListManager, ContentListManager } from './table-style';

function ListManagerRegionl({ listManagers = [] }) {
  return (
    <>
      <ContainerListManager>
        <ContentListManager>
          {listManagers
            .slice(0, listManagers.length <= 3 ? listManagers.length : 2)
            .map((c) => (
              <BaSeSmall1 color="#939393" key={c.name}>
                {c.name}
              </BaSeSmall1>
            ))}
          {listManagers.length > 3 && (
            <BaSeSmall1 color="#939393">...</BaSeSmall1>
          )}
        </ContentListManager>

        {listManagers.length > 3 && (
          <BaSePopupButton
            alertSize={200}
            name="exclamation-circle"
            direction="right"
            iconProps={{
              color: '#0000C9',
              name: 'exclamation-circle',
              size: 15,
            }}
            message={listManagers.map((c, index) => {
              return (
                <BaSeSmall1 color="#939393" key={c.name}>
                  {c.name}
                </BaSeSmall1>
              );
            })}
            title="exclamation-circle"
          />
        )}
      </ContainerListManager>
    </>
  );
}

export default ListManagerRegionl;
